let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gr56x")).then(() => parcelRequire('2a3IQ'));